import { lazy } from 'react'
import { KambiSportName } from '@mobi/api-types/kambi/sports'
import type { MappedSportWithFlagsProps } from './types'

export const mappedSportsWithNationalFlags: Partial<
  Record<KambiSportName, React.LazyExoticComponent<React.FC<MappedSportWithFlagsProps>>>
> = {
  FORMULA_1: lazy(() => import('./Sports/Formaula1/F1')),
  MARTIAL_ARTS: lazy(() => import('./Sports/MartialArt/MartialArt')),
  GOLF: lazy(() => import('./Sports/Golf/Golf')),
  TENNIS: lazy(() => import('./Sports/Tennis/Tennis')),
  AUSTRALIAN_RULES: lazy(() => import('./Sports/AustralianRules/AustralianRules')),
  AMERICAN_FOOTBALL: lazy(() => import('./Sports/AmericanFootball/AmericanFootball')),
  BASEBALL: lazy(() => import('./Sports/Baseball/Baseball')),
  BASKETBALL: lazy(() => import('./Sports/Basketball/BasketBall')),
  CRICKET: lazy(() => import('./Sports/Cricket/Cricket')),
  FOOTBALL: lazy(() => import('./Sports/Football/Football')),
  ICE_HOCKEY: lazy(() => import('./Sports/IceHockey/IceHockey')),
  RUGBY_LEAGUE: lazy(() => import('./Sports/RugbyLeague/RugbyLeague')),
  RUGBY_UNION: lazy(() => import('./Sports/RugbyUnion/RugbyUnion')),
  V8_SUPERCARS: lazy(() => import('./Sports/V8Supercars/V8Supercars')),
  NASCAR: lazy(() => import('./Sports/Nascar/Nascar')),
  SPEEDWAY: lazy(() => import('./Sports/Speedway/Speedway')),
}
